import { Reveal, SectionLabel } from "@/components/Reveal";

const STEPS = [
  {
    n: "01",
    title: "Share Your Requirements",
    text: "Tell us about your patent portfolio, database, validation requirements, or deadline-checking needs.",
  },
  {
    n: "02",
    title: "Data Review",
    text: "Our team reviews the relevant patent records and identifies information requiring validation.",
  },
  {
    n: "03",
    title: "Validation & Quality Checks",
    text: "Patent information is systematically checked against appropriate source records and predefined validation criteria.",
  },
  {
    n: "04",
    title: "Deliver Verified Results",
    text: "Receive structured validation results highlighting verified information, discrepancies, and items requiring further review.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <SectionLabel index="03">Process</SectionLabel>
          <h2 className="font-display font-bold text-navy text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-[1.05] mb-20 max-w-3xl">
            A disciplined process, from brief to verified results
          </h2>
        </Reveal>

        <div>
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.06}>
              <div
                data-testid={`process-step-${s.n}`}
                className="group grid lg:grid-cols-12 gap-6 lg:gap-10 items-baseline py-10 lg:py-14 border-t border-slate-200 last:border-b hover:bg-slate-50 transition-colors duration-500 px-2 lg:px-6"
              >
                <span className="lg:col-span-3 font-display font-black text-6xl lg:text-8xl text-slate-200 group-hover:text-accent transition-colors duration-500 leading-none tracking-tighter">
                  {s.n}
                </span>
                <h3 className="lg:col-span-4 font-display font-bold text-navy text-xl lg:text-2xl tracking-tight">
                  {s.title}
                </h3>
                <p className="lg:col-span-5 text-slate-600 text-base leading-relaxed">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
